import {
  DIGITAL,
  IKEA_FAMILY_ONLY,
  IKEA_BUSINESS_NETWORK_ONLY,
} from '../../enums';
import { CSSEvent } from '../../types/model';
import { Colors } from '../Card/Badges';
import cssIngka from '@ingka/variables/colours-css';

const getBadges = (event: CSSEvent) => {
  const badges: [string, Colors][] = [];
  const isDigitalEvent = event.location.type === DIGITAL;

  if (event.loyaltyEvent === IKEA_FAMILY_ONLY) {
    badges.push([
      'event.ikeaFamilyOnly',
      {
        background: cssIngka.colourCommercialMessageIkeaFamily,
        // WCAG 1.4.3: colourCommercialMessageIkeaFamily resolves to #007cc1 (blue).
        // White (#FFFFFF) on #007cc1 = 4.53:1 ✓ PASS.
        // Black (#111111) on #007cc1 = 4.17:1 ✗ FAIL — do NOT use black here.
        text: cssIngka.colourStaticWhite,
      },
    ]);
  }

  if (event.loyaltyEvent === IKEA_BUSINESS_NETWORK_ONLY) {
    badges.push([
      'event.ikeaBusinessNetworkOnly',
      {
        background: cssIngka.colourStaticWhite,
        text: cssIngka.colourStaticBlack,
        // WCAG 1.4.11: white badge needs a visible boundary (≥3:1) against
        // light card backgrounds; colourNeutral7 achieves this
        border: cssIngka.colourNeutral7,
      },
    ]);
  }

  if (isDigitalEvent) {
    badges.push([
      'event.digitalEvent',
      {
        background: cssIngka.colourStaticIkeaBrandYellow,
        text: cssIngka.colourStaticBlack,
      },
    ]);
  }

  return badges;
};

export default getBadges;
